import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AbstractAcademicEditComponent, mapStateToProps } from './abstract'
import { Sidebar } from '~/components/sidebar'
import { Header } from '~/components/header'
import { Table } from '~/components/table'
import * as route from '~/helper/constant/route'
import { Button, Input } from '~/components/form'
import { Loading } from '~/components/loader'
import DatePicker from 'react-datepicker'
import * as Status from '~/helper/constant/status'
import { withTranslation } from 'react-i18next'
import { convertADtoBS } from '../../../../helper/function'
class AcademicEditComponent extends AbstractAcademicEditComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
        this._startDate = this._startDate.bind(this)
        this._endDate = this._endDate.bind(this)
    }

    _startDate(data) {
        this._handleChange('from_date', data)
    }

    _endDate(data) {
        this._handleChange('to_date', data)
    }

    render() {
        const { t } = this.props
        return (
            <div className="main-page">
                <Loading status={this.state.loading} text={this.state.loading_text} />
                <Sidebar id="academic" />
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.admin.academic.view}>{t('academic:breadcrumb')} > </a>
                            </li>
                            <li>{t('academic:editLink')}</li>
                        </ul>
                        <div className="row clearfix">
                            <div className="col-md-12 float-left">
                                <h5 className="main-title heading5">{t('academic:editTitle')}:</h5>
                            </div>
                        </div>
                    </div>
                    <div className="main-form">
                        <form>
                            {this.state.status == Status.INACTIVE && (
                                <div className="row clearfix">
                                    <div className="col-sm-12 float-left form-group">
                                        <div className="alert alert-primary" role="alert">
                                            {t('academic:edit.academicStatusInactive')}.
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="row clearfix">
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('academic:add.label')} *</label>
                                    {this.state.status == Status.INACTIVE && <Input disabled="disabled" name="name" placeholder={t('academic:add.placeholder')} type="text" value={this.state.name} />}
                                    {this.state.status != Status.INACTIVE && <Input onChange={this._handleChange} name="name" placeholder={t('academic:add.placeholder')} type="text" value={this.state.name} />}

                                    {this.state.errors.name && <label className="error text-danger setup-error text-left">{this.state.errors.name}</label>}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title text-left">{t('academic:add.startdate-label')} *</label>
                                    {this.state.status == Status.INACTIVE && <DatePicker disabled="disabled" dateFormat="yyyy-MM-dd" className="form-control" onChange={this._startDate} selected={this.state.from_date} placeholderText={t('academic:add.startdate-placeholder')} />}
                                    {this.state.status != Status.INACTIVE && <DatePicker dateFormat="yyyy-MM-dd" className="form-control" onChange={this._startDate} selected={this.state.from_date} placeholderText={t('academic:add.startdate-placeholder')} />}
                                    {this.props.school != null && this.props.school.school != null && this.props.school.school.date_format == 'BS' && <label className="date-bs">{this.state.from_date != '' ? (convertADtoBS(this.state.from_date) != null ? convertADtoBS(this.state.from_date) + ' BS' : 'Invalid Date Range') : ''}</label>}
                                    {this.state.errors.from_date && <label className="error text-danger setup-error text-left">{this.state.errors.from_date}</label>}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title text-left">{t('academic:add.enddate-label')} *</label>
                                    {this.state.status == Status.INACTIVE && <DatePicker disabled="disabled" dateFormat="yyyy-MM-dd" className="form-control" onChange={this._endDate} selected={this.state.to_date} placeholderText={t('academic:add.enddate-placeholder')} />}
                                    {this.state.status != Status.INACTIVE && <DatePicker dateFormat="yyyy-MM-dd" className="form-control" onChange={this._endDate} selected={this.state.to_date} placeholderText={t('academic:add.enddate-placeholder')} />}
                                    {this.props.school != null && this.props.school.school != null && this.props.school.school.date_format == 'BS' && <label className="date-bs">{this.state.to_date != '' ? (convertADtoBS(this.state.to_date) != null ? convertADtoBS(this.state.to_date) + ' BS' : 'Invalid Date Range') : ''}</label>}
                                    {this.state.errors.to_date && <label className="error text-danger setup-error  text-left">{this.state.errors.to_date}</label>}
                                </div>
                            </div>
                            <div className="row clearfix">
                                <div className="col-sm-3 float-left form-group">
                                    {this.state.status == Status.INACTIVE && <Button onClick={this._onBack} type="submit" text={t('academic:edit.back')} main={true} />}
                                    {this.state.status != Status.INACTIVE && <Button onClick={this._onSave} type="submit" text={t('common:updateBtn')} main={true} />}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

const AcademicEdit = withTranslation()(connect(mapStateToProps)(AcademicEditComponent))

export { AcademicEdit }
